module.exports = __webpack_public_path__ + "img/TwoAxleTractorTwoAxleSemitrailer.3d211bb0.svg";